import mainLogo from '../../images/ItavemaVolvo/VolvoIntercar_logo_preto.png';
import squareLogoSmall from '../../images/ItavemaVolvo/VolvoIntercar_logo_preto_square.png';
import squareLogo from '../../images/ItavemaVolvo/VolvoIntercar_logo_preto_square.png';
import mainLogoWhite from '../../images/ItavemaVolvo/VolvoIntercar_logo_branco.png';
import banner01 from '../../images/ItavemaVolvo/itvaVolvo_banner_01.jpg';
import banner02 from '../../images/ItavemaVolvo/itvaVolvo_banner_02.jpg';
import banner03 from '../../images/ItavemaVolvo/itvaVolvo_banner_03.jpg';
import car123 from '../../images/ItavemaVolvo/123_ex30.jpg';
import box123 from '../../images/ItavemaVolvo/123_itvaVolvo.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Itavema Volvo',
    defaultStoreLink: 'pecasvolvo.itavema.com.br',
    defaultContactEmail: 'atendimentovolvo@itavema.com.br',
    whatsappNumber: '11 3646 4945',
    CNPJ: '07.512.967/0027-30',
    CNPJname: 'ITVA COMERCIO DE VEICULOS LTDA',
    CNPJaddress: 'R. Clélia, 440 - anexo parte III, São Paulo - SP, CEP: 05042000',
    launchDate: '18/02/2025',

    multiContact: {},

    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "volvo",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "ITVA VOLVO VILA OLIMPIA"
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        // {
        //     name: 'Óleos',
        //     img: 'tabOleos',
        //     products: SliderProducts.Oleos
        // },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogoSmall,
    bannerLogoWhite: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Itavema Volvo</mark>.',

    aboutUs: {
        title: 'Itavema Volvo',
        content: [
            'O Grupo representa importantes montadoras do cenário nacional: Volvo, Toyota, Volvo, Fiat, Volvo, BYD e Dafra. Com unidades no Rio de Janeiro, Grupo Itavema é sinônimo de qualidade e confiança.',
            'Prezando pela excelência no atendimento aos nossos clientes, as lojas da Volvo Itavema France oferecem ao público opções em veículos 0km, seminovos e na prestação dos serviços pós-venda, através das revisões periódicas, fornecimento de peças e reparos.',
        ],
        link: 'https://itavema.com.br/quem-somos/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/volvointercarvocal/',
        Facebook: 'https://www.facebook.com/VolvoIntercarvocal/',
        LinkedIn: 'https://www.linkedin.com/company/intercar-vocal-motors-ltda/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [
        'Volvo Rib - RUA RIBEIRÃO CLARO, 194/240 - Vila Olímpia - 04549-050 - 05.522.808/0001-52',
    ],
}